import { render, staticRenderFns } from "./AsignacionSeriado.vue?vue&type=template&id=b005951e&"
import script from "./AsignacionSeriado.vue?vue&type=script&lang=ts&"
export * from "./AsignacionSeriado.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionSeriado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports